//shoprises 有品页面的数据展示图

import React, { useEffect } from "react";
import { Chart } from "@antv/g2";
import { useI18n } from "@src/i18n";
const OwnChart = ({ data = [], id }) => {
  const { t } = useI18n();

  useEffect(() => {
    const chart = new Chart({
      container: "chartContainer" + id,
      autoFit: true,
      height: 160,
    });
    const value = [];
    data.forEach((item) => {
      value.push({
        year: item.ad_date?.substr(5),
        adCount: item.ad_num,
      });
    });
    const defs = {
      year: {
        type: "time",
      },
    };

    chart.source(value, defs);
    chart.scale("adCount", {
      alias: t("shoprisePage.deliveryCount"),
    });
    chart.scale("year", {
      range: [0, 1],
      tickCount: 4,
    });
    chart.tooltip({
      crosshairs: {
        type: "line",
      },
    });
    chart.line().position("year*adCount");
    chart.point().position("year*adCount").size(0).shape("circle").style({
      stroke: "#fff",
      lineWidth: 1,
    });
    chart.render();
    return () => {
      chart.destroy();
    };
  }, [data, id, t]);
  return <div id={"chartContainer" + id} style={{ padding: "0 3px" }} />;
};

export default OwnChart;
